export const UPDATE_ALL_CALLS_UI_STATE = 'UPDATE_ALL_CALLS_UI_STATE';

export const updateAllCallsUiState = (updates) => async (dispatch, getState) => {
  return dispatch({
    type: UPDATE_ALL_CALLS_UI_STATE,
    updates,
  });
};
